import { ca } from '@cian/analytics';

export type TFavoriteEventSource = 'about_building';

// Добавление ЖК в избранное
export function trackingActionAddFromCardJG(gaLabel: string, newbuildingId: number, source?: TFavoriteEventSource) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'favorite',
    action: 'add_from_card_JK',
    label: gaLabel,
    oid: newbuildingId,
    useLastProducts: true,
    ...(source && { page: { extra: { source } } }),
  });
}

// Удаление ЖК из избранного
export function trackingActionRemoveFromCardJK(gaLabel: string, newbuildingId: number, source?: TFavoriteEventSource) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'favorite',
    action: 'remove_from_card_JK',
    label: gaLabel,
    oid: newbuildingId,
    useLastProducts: true,
    ...(source && { page: { extra: { source } } }),
  });
}
